import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import { List, ListActions, NumberInput } from "react-admin";
import { checkPermission } from "server/security/utils";
import ScholarshipBudgetTable from "./components/ScholarshipBudgetTable";

const ListScholarshipBudget = () => {
  const filter = [
    <NumberInput
      source="fiscalYear"
      label="Календарна година"
      alwaysOn
      fullWidth
    />,
  ];

  return (
    <List
      exporter={false}
      title="Бюджет за стипендии"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canCreateScholarshiBudgets)} />}
      filters={filter}
    >
      <ScholarshipBudgetTable />
    </List>
  );
};

export default ListScholarshipBudget;
